module.exports = __webpack_public_path__ + "img/pos5_s2.48bc3357.png";